export default [
  {
    location: "eSpoc (Vericle)",
    title: "Front-end Intern",
    timeframe: "January 2018 - June 2018",
    info:
      "Throughout this internship, I designed a bug report/feature request form using Angular 6 and Material Design.",
  },
  {
    location: "Rowan University",
    title: "Research Assistant",
    timeframe: "February 2019 - October 2020",
    info:
      "In this rearch team, I helped my professor to discover the effects of varying codebooks on ECOC Machine Learning",
  },
];
